@if (staticMapUrl || (mapUrl$ | async); as url) {
  @if (config?.lazy) {
    <img
      [lazyLoad]="url"
      [src]="'/maps/map-placeholder.svg' | staticImageUrl"
      [attr.loading]="config?.lazy ? 'lazy' : 'none'"
      [class]="config?.class"
      [style.max-height.px]="config?.height"
      [style.max-width.px]="config?.width"
      (click)="mapClicked.emit()"
      aria-hidden="true"
      alt="" />
  } @else {
    <img
      [src]="url"
      [class]="config?.class"
      [style.max-height.px]="config?.height"
      [style.max-width.px]="config?.width"
      (click)="mapClicked.emit()"
      alt=""
      aria-hidden="true" />
  }
} @else {
  <img
    [class]="config?.class"
    [style.max-height.px]="config?.height"
    [style.max-width.px]="config?.width"
    [src]="'/maps/map-placeholder.svg' | staticImageUrl"
    (click)="mapClicked.emit()"
    alt="map placeholder"
    aria-hidden="true" />
}
